// Convenience object for API calls
import * as api from './api';

export {
  getActiveIncidents,
  acknowledgeIncident,
  takeoverIncident,
  escalateIncident,
  closeIncident,
  updateIncidentSeverity,
  updateIncidentStatus,
  updateIncidentTags,
  getIncidentComments,
  addIncidentComment,
  getSettings,
  saveSettings,
  setAuthTokenProvider,
  createTestIncident,
  getOperators,
  ApiError,
  extractApiErrorMessage,
} from './api';

export const apiClient = api;

export {
  startConnection,
  stopConnection,
  onMessage,
  onConnectionStatus,
  retryConnection,
  setSignalRTokenProvider,
} from './signalr';

export type { ConnectionStatus, SignalRMessageHandler, ConnectionStatusHandler } from './signalr';

export {
  msalConfig,
  loginRequest,
  silentRequest,
  apiScopes,
  isMsalConfigured,
  securityGroupConfig,
  mapGroupsToAppRoles,
  hasAppAccess,
} from './msalConfig';

export {
  initializeTeams,
  isRunningInTeams,
  getTeamsSsoToken,
  getTeamsContext,
  getTeamsTheme,
  onThemeChange,
  notifyAuthSuccess,
  notifyAuthFailure,
} from './teamsService';
